import { underscore } from '@ember/string';
import rpc from '@square/dashboard-utilities/clients/rpc';
import { JediService } from '@square/dashboard-protos/models/squareup/jedi/service';
const JEDI_URL = '/api/v1/jedi/session';
export default JediService.create(rpc((method, guessedUrl) => {
  switch (method) {
    case JediService.methods.GetPanel:
      return `${JEDI_URL}/${underscore(method.name)}`;
    case JediService.methods.StartSession:
      return `${JEDI_URL}/start`;
    default:
      return guessedUrl;
  }
}));